export default __webpack_public_path__ + "static/media/ListItem-prototype.2c7bd54c.mp4";